import { render, staticRenderFns } from "./experience_comments.vue?vue&type=template&id=9ea465fc&"
import script from "./experience_comments.vue?vue&type=script&lang=js&"
export * from "./experience_comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports